import {Button, ButtonProps} from '@material-ui/core'
import Styled from '../Styled'
import styles from './styles'

const TheButton = Styled(Button, styles.buttonLarge)

export type Props = ButtonProps & {
  children: React.ReactNode
  style?: any
}

const ButtonLarge: React.FC<Props> = (props: Props) => {
  let color = props.color
  if (!color) {
    color = 'primary'
  }
  return (
    <TheButton {...props} color={color} variant={'contained'}>
      {props.children}
    </TheButton>
  )
}

export default ButtonLarge
